var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-empty",
    class: {
      'onlyShowSelected': _vm.onlyShowSelected
    }
  }, [_c('div', {
    staticClass: "empty-img"
  }), !_vm.onlyShowSelected ? _c('div', {
    staticClass: "tips"
  }, [_vm._v("暂无内容")]) : _c('div', {
    staticClass: "tips"
  }, [_vm._v("店主还没有添加商品哦~")])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };